import { render, staticRenderFns } from "./item-index.vue?vue&type=template&id=00787af2&"
import script from "./item-index.vue?vue&type=script&lang=js&"
export * from "./item-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports